module.exports = __webpack_public_path__ + "static/images/download.da6e2721.svg";